import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import Slider from 'material-ui/Slider';

import MdImage from 'react-icons/lib/md/image';
import MdClose from 'react-icons/lib/md/close';
import MdRotateLeft from 'react-icons/lib/md/rotate-left';
import MdRotateRight from 'react-icons/lib/md/rotate-right';
import './Toolbar.css';

class Toolbar extends Component {
  constructor (props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.showImage = this.showImage.bind(this);
  }


  handleClick = function (e) {
    this.imageInput.click();
  }

  showImage = function () {
    this.props.loadImage(this.imageInput.files[0]);
  }

  render () {
    return (
      <div>
        <ul className='toolbar'>
          <li onClick={this.handleClick}>
            <input id='imageInput' type="file" accept='image/*' ref={(ref) => { this.imageInput = ref; }} onChange={this.showImage} style={{display:'none'}} />
            <MdImage size={20} />
          </li>
          <li onClick={this.props.leftRotate}><MdRotateLeft size={20} /></li>
          <li onClick={this.props.rightRotate}><MdRotateRight size={20} /></li>
          <li onClick={this.props.reset}><MdClose size={20} /></li>
        </ul>
        <MuiThemeProvider>
          <Slider
            min={0}
            max={1}
            value={this.props.grayscale}
            disabled={!this.props.originalImg}
            onChange={this.props.makeGray} />
        </MuiThemeProvider>
      </div>
    );
  }
}

export default Toolbar;



// WEBPACK FOOTER //
// ./src/toolbar/Toolbar.js